var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('div',{staticClass:"level1"},[_c('h2',{staticClass:"level-line1"},[_vm._v(_vm._s(_vm.options.titleCh))])]),_c('p',{staticClass:"level2"},[_vm._v(_vm._s(_vm.options.description))]),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }